<template>
    <div>
        <el-dialog
            :visible.sync="showDialog"
            :modal-append-to-body="false"
            width="65%"
            @close="closeReportDialog"
            append-to-body
        >
            <div class="print" id="report">
                <div class="page">
                <div class="table">
                    <h2 style="text-align:center;">报 告</h2>
                    <table style="width:100%;" border="1">
                        <tr>
                            <td>
                                <span class="title">项目名称:</span>
                                <span class="content"> {{ printData.projectName }}</span> 
                            </td>
                            <td>
                                <span class="title">巡检班组:</span> 
                                <span class="content"> {{ printData.groupName }} </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span class="title">任务开始时间:</span> 
                                <span class="content"> {{ printData.startTime }} </span>
                            </td>
                            <td>
                                <span class="title">任务结束时间:</span> 
                                <span class="content"> {{ printData.endTime }} </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span class="title">巡检数量:</span> 
                                <span class="content"> {{ printData.allCount }} </span>
                            </td>
                            <td>
                                <span class="title">异常数量:</span> 
                                <span class="content"> {{ printData.errorCount }} </span>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <span class="title">巡检人:</span> 
                                <span class="content"> {{ printData.realUserNames }} </span>
                            </td>
                        </tr>
                    </table>
                    <table class="task-Detail" border="1px" style="width:100%;border-top:none;">
                        <tr >
                            <th>序号</th>
                            <th>设备名称</th>
                            <th>巡检状态</th>
                            <th>巡检明细</th>
                        </tr>
                        <tr v-for="(item,index) in printData.taskLists" :key="item">
                            <td style="width:50px;">
                               {{ index+1 }}
                            </td>
                            <td style="min-width:150px;">
                                {{ item.deviceName }}
                            </td>
                            <td style="width:100px;">
                                {{ item.errorFlag==1?'异常':'正常' }}
                                
                                <!-- 春眠不觉晓，处处蚊子咬。打上敌敌畏，不止是多少。 -->
                            </td>
                            <td>
                                {{ item.standards }}
                                <!-- 春眠不觉晓，处处蚊子咬。打上敌敌畏，不止是多少。 -->
                            </td>
                        </tr>
                        
                    </table>
                </div>
                </div>
            </div>
            
        
        <template slot="footer">
            <div>
            <el-button type="primary" @click="print"><span class="el-icon-printer" ></span>  打 印</el-button>
            </div>
        </template>
        </el-dialog>
    </div>
</template>
<script>
import table from '../../../util/table.vue'
export default {
  components: { table },
    props:{
        show:{
            type:Boolean,
        },
        // printData:{
        //     type:Object,
        //     default:{},
        // }
    },
    data(){
        return{
            showDialog:false,
            printData:{},
        }
    },
    methods:{
        // 打开弹窗
        openDialog(data){
            this.showDialog = true;
            this.printData = data;
            console.log(this.printData)
        },
        // 打印方法
        print(){
            console.log(this.printData)
            Print('#report', {
                onStart: function () {
                console.log('onStart', new Date())
                },
                onEnd: function () {
                console.log('onEnd', new Date())
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
    .page{
        width: 21cm;
        max-height: 29.7cm;
        padding: 3.5mm;
        margin: 0 auto;
        // border: 1px #D3D3D3 solid;
        border-radius: 5px;
        background: white;
        overflow: hidden;
        // box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    }
    .title{
        margin-left: 5px;
        font-weight: bold;
    }
    th{
        height: 40px;
        line-height: 40px;
    }
    td{
        
        height: 40px;
        line-height: 40px;
    }
    .task-Detail{
        td{
            text-align: center;
            height: 40px;
            line-height: 40px;
        }
    }
    @page
        {
            size: A4;
            margin: 0;
        }
        @media print
        {
            *{
                padding: 0px;
                margin: 0px;
            }
            .page
            {   
                margin: 0;
                border: initial;
                border-radius: initial;
                width: initial;
                min-height: initial;
                box-shadow: initial;
                background: initial;
                page-break-after: always;
            }
        }
</style>